import React, { useEffect, useState } from 'react';
import { GetEnquiry } from '../../../_seivices';
import Layout from '../../shared/Layout';
import DataTable from 'react-data-table-component';

const Enquiry = () => {

    const [loading, setLoading] = useState(false);
    const [blogData, setBlogData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const fetchGetEnquiry = async () => {
        try {
            const data = await GetEnquiry();
            setBlogData(data);
        } catch (error) {
           return null;
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchGetEnquiry();
    }, [])

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleRowsPerPageChange = (newRowsPerPage, page) => {
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(page);
    };

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => ((currentPage - 1) * rowsPerPage) + index + 1,
            width: '80px',
            center: true,
            sortable: false
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            width: '200px'
        },
        {
            name: 'Email Id',
            selector: row => row.emailId,
            sortable: true,
            width: '300px'
        },
        {
            name: 'Contact No',
            selector: row => row.contactNo,
            sortable: true,
            width: '150px'
        },
        {
            name: 'Work Type',
            selector: row => row.workTypeName,
            sortable: true,
            width:"200px"
        },
        {
            name: 'Description',
            selector: row => row.remark,
            sortable: true,
            minWidth:"350px"
        },
        {
            name: 'Entry Date',
            selector: row => row.createdDate ? new Date(row.createdDate).toISOString().slice(0, 10) : '',
            sortable: true,
            width:"200px"
        },
    ];



    return (


        <Layout>
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Enquiry Detail</h4>
                    </div>

                </div>
            </div>

            <div className="datatable mt-3">
                <DataTable
                    fixedHeader
                    fixedHeaderScrollHeight="calc(100vh - 220px)"
                    columns={columns}
                    data={blogData || []}
                    progressPending={loading}
                    progressComponent={<p>Loading...</p>}
                    pagination
                    paginationPerPage={rowsPerPage}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    highlightOnHover
                />
            </div>
        </Layout>

    );

};

export default Enquiry;

